import React, { ChangeEvent } from 'react';
import { Container, ButtonMarcarDesmarcar } from './styles';

import { Col, Row } from 'react-bootstrap';
import Separator from '~/components/Separator';
import { AiFillSave } from 'react-icons/ai';
import Tippy from '@tippyjs/react';
import { HotKeys } from 'react-hotkeys';
import { InputDate } from '~/components/NovosInputs';
import ModalCaptura from './components/ModalCaptura/ModalCaptura';
import { useAceiteDePagamento } from './hooks/useAceiteDePagamento';
import { DataTable } from './components/DataTable/DataTable';
import { AceiteInfos } from './components/AceiteInfos/AceiteInfos';
import { GroupButtons } from './components/GroupButtons/GroupButtons';
import { ActionsButtons } from './components/ActionsButtons/ActionsButtons';
import { SearchInputs } from './components/SearchInputs/SearchInputs';
import FormDefault from '~/components/FormDefault';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

export const AceiteDePagamentoContent: React.FC = () => {
  const {
    setValue,
    register,
    control,
    com_aceite,
    isTitulos,
    onSave,
    keyMap,
    keyHandlers,
    errors,
    clearErrors,
    loaderTela,
    handleCheckAll,
  } = useAceiteDePagamento();

  return (
    <HotKeys id="hotkeys" keyMap={keyMap} handlers={keyHandlers} tabIndex={-1}>
      <ModalCaptura />
      <Container>
        <FormDefault
          codTela={173}
          title="Aceite de Pagamento"
          onSave={() => Promise.resolve()}
          onCancel={() => []}
          onClearFields={() => []}
          onNew={() => []}
          onDelete={() => []}
          onReturnSearch={() => []}
          isDelete={false}
          isNew={false}
          isCancel={false}
          isClear={false}
          isSave
          customButtons={
            <Tippy
              placement="bottom"
              content="CTRL + ALT + S"
              arrow
              animation="scale"
              appendTo={() => document.body}
              trigger="mouseenter focus"
              zIndex={9999}
            >
              <span
                style={{ display: 'inline-flex', alignItems: 'stretch' }}
                onClick={(e) => e.stopPropagation()}
              >
                <CustomButtonNovo
                  icon={AiFillSave}
                  disabled={!isTitulos || loaderTela}
                  onClick={async () => {
                    await onSave();
                  }}
                  style={{ backgroundColor: '#28a745' }}
                >
                  Gravar
                </CustomButtonNovo>
              </span>
            </Tippy>
          }
        >
          <SearchInputs />
          <Row>
            <GroupButtons />
            <Col md={2} sm={12}>
              <InputDate
                control={control}
                register={register}
                name="dta_inicio"
                label="Data de Início"
                isError={errors.dta_inicio}
                disabled={isTitulos}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  clearErrors('dta_inicio');
                  setValue('dta_inicio', e.target.value);
                }}
              />
            </Col>
            <Col md={2} sm={12}>
              <InputDate
                control={control}
                register={register}
                name="dta_final"
                label="Data do Fim"
                isError={errors.dta_final}
                disabled={isTitulos}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  clearErrors('dta_final');
                  setValue('dta_final', e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <ActionsButtons />
          </Row>
          <Separator childrenWidth="270px">
            <div style={{ display: 'flex' }}>
              <ButtonMarcarDesmarcar
                type="button"
                style={{
                  marginTop: '-7px',
                }}
                onClick={() => {
                  handleCheckAll(false);
                }}
              >
                Desmarcar Todas
              </ButtonMarcarDesmarcar>{' '}
              |
              <ButtonMarcarDesmarcar
                type="button"
                style={{
                  marginTop: '-7px',
                }}
                onClick={() => {
                  handleCheckAll(true);
                }}
              >
                Marcar Todas{' '}
              </ButtonMarcarDesmarcar>
            </div>
          </Separator>
          <Col md={12} sm={12}>
            <DataTable />
          </Col>
          {!com_aceite && <AceiteInfos />}
        </FormDefault>
      </Container>
    </HotKeys>
  );
};
